import { CookieBanner } from "@iec-id/ui";
import { useTranslation } from "react-i18next";
import { useAnalyticsConsent } from "@/lib/analytics";
import { cookiesDocumentHref, useCookieBannerLabels } from "./cookie-labels";
import { useCookieRegistry } from "./use-cookie-registry";

/**
 * Баннер cookie витрины. Монтируется один раз в корне приложения.
 *
 * Три вещи, которые делает этот компонент и которые нельзя разнести по разным
 * местам, не получив расхождения:
 *
 *   1. показывает баннер, пока решения нет;
 *   2. записывает решение и в браузер, и в реестр согласий;
 *   3. держит гейт аналитики в соответствии с решением — включая отзыв из
 *      соседней вкладки.
 *
 * Пока ответ сервера не пришёл, баннер не рисуется: у вошедшего человека
 * решение уже может лежать в реестре, и мигнувший баннер выглядел бы так,
 * будто согласие спрашивают повторно.
 */
export function CookieConsent() {
	const { i18n } = useTranslation();
	const labels = useCookieBannerLabels();
	const registry = useCookieRegistry();

	useAnalyticsConsent();

	if (registry.isPending) return null;

	return (
		<CookieBanner
			labels={labels}
			documentHref={cookiesDocumentHref(i18n.language)}
			onDecision={(consent) => registry.save(consent.choices, "cookie_banner")}
			renderLink={({ href, children }) => (
				<a href={href} target="_blank" rel="noreferrer noopener" className="underline">
					{children}
				</a>
			)}
		/>
	);
}
